// ── helper مشترك لإدارة المحتوى عبر السيرفر ───────────────────
// نفس نمط useData.js بالظبط (apiUrl + emp_token)، لكن standalone عشان
// الكومبوننتس اللي بتكتب على الـ DB مباشرة تستخدمه:
//   - Dashboard.jsx  (مدير الجانبين: sidebar_playlists + sidebar_items)
//   - modals/index.jsx (الإعدادات: social_links)
// السيرفر بيتأكد من توكن الموظف + الصلاحية + قائمة CONTENT_TABLES،
// وبيكتب بمفتاح الخدمة (بيتخطى RLS) — فالكتابة تفضل شغّالة بعد قفل الجداول.
import { apiUrl } from './supabase';

const empToken = () => {
  try { return localStorage.getItem('emp_token') || ''; } catch { return ''; }
};

// حفظ صف: insert لو مفيش row.id، update لو فيه row.id.
// بيرجّع { ok:true, row } عند النجاح، أو { error } عند الفشل.
export async function contentSave(table, row) {
  try {
    const res = await fetch(apiUrl('/api/admin/content-save'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: empToken(), table, row }),
    });
    const r = await res.json().catch(() => ({}));
    if (res.ok && r.ok && r.row) return { ok: true, row: r.row };
    return { error: r.message || 'فشل الحفظ' };
  } catch (e) {
    return { error: 'فشل الاتصال بالسيرفر' };
  }
}

// حذف صف بالـ id. بيرجّع { ok:true } أو { error }.
export async function contentDelete(table, id) {
  try {
    const res = await fetch(apiUrl('/api/admin/content-delete'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: empToken(), table, id }),
    });
    const r = await res.json().catch(() => ({}));
    return (res.ok && r.ok) ? { ok: true } : { error: r.message || 'فشل الحذف' };
  } catch (e) {
    return { error: 'فشل الاتصال بالسيرفر' };
  }
}

// ── المسميات المخصّصة (custom_labels) — مفتاحها 'key' ──
export async function labelSave(key, ar_value, en_value, category) {
  try {
    const res = await fetch(apiUrl('/api/admin/labels-save'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: empToken(), key, ar_value, en_value, category }),
    });
    const r = await res.json().catch(() => ({}));
    if (res.ok && r.ok) return { ok: true, row: r.row };
    return { error: r.message || 'فشل حفظ المسمى' };
  } catch (e) {
    return { error: 'فشل الاتصال بالسيرفر' };
  }
}

export async function labelDelete(key) {
  try {
    const res = await fetch(apiUrl('/api/admin/labels-delete'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: empToken(), key }),
    });
    const r = await res.json().catch(() => ({}));
    return (res.ok && r.ok) ? { ok: true } : { error: r.message || 'فشل حذف المسمى' };
  } catch (e) {
    return { error: 'فشل الاتصال بالسيرفر' };
  }
}
